import createModule from "../createModule"
import view from "./view"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getIsOpPro } from "modules/account-root/selectors"
import { getTabs, getTeams } from "./selectors"

import "./styles.scss"

export default createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "teams",
    passthrough: true,
    url: () => {
      return {
        query: `query {
          teams {
            id
            alias
            name
            description
            createdAt
            updatedAt
            role
          }
        }`,
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    teams: getTeams(state, props),
    role: getRole(state, props),
    isOpPro: getIsOpPro(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
})
